import { IBankAccount } from "src/shared/types/partnerBankAccount";
import { ICountry, IAddressFull } from "./address.types";
import { INameValue, EAgencies, EStatus } from "./common.types";
import {
  IActivitySphere,
  EOrganizationValue,
  IOwnership,
  ILicense,
} from "./companies.types";
import { ESexOptions, IEmployee } from "./person.types";

export enum EPartnerPriority {
  VIP = "VIP",
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
  N = "N",
}

export enum EPartnerEasyService {
  Easy_service = 2,
  Easy_service_ic = 3,
  Disabled = 1,
}

export enum EClientRegion {
  BYMinsk = "Минск",
  RUMoscow = "Москва",
  Region = "Регион",
}

export interface IPartnerDto {
  activity_spheres: Array<IActivitySphere>;
  agency: INameValue<EAgencies>;
  carrot_quest: INameValue<number>;
  creator: IEmployee;
  easy_service: INameValue<EPartnerEasyService>;
  easy_service_phone: INameValue<number>;
  edin_email: Array<string> | null;
  fax: string | null;
  id: number;
  is_EDMS_enabled: boolean;
  is_in_blacklist: boolean;
  is_nda_signed?: boolean;
  nda_note?: string | null;
  nda_file?: string;
  state_registration_certificate?: string;
  is_resident: boolean;
  is_survey_available: boolean;
  manager_additional: IEmployee;
  manager_main: IEmployee;
  organization_form: INameValue<EOrganizationValue>;
  name: string;
  nonresident_email: string | null;
  nonresident_phone: string | null;
  ownership: IOwnership;
  phone: string;
  priority: INameValue<EPartnerPriority>;
  region: EClientRegion;
  registration_country: ICountry;
  registration_number?: string;
  status: INameValue<EStatus>;
  okpo: string | null;
  kpp: string | null;
  ogrn: string | null;
  isInBlacklist: boolean;
  // entities
  license?: ILicense | null;
  contact_persons: Array<IPartnerContactDTO>;
  addresses?: Array<IAddressFull>;
  bank_account?: IBankAccount;
  //1c_integration
  integration_1c?: {
    is_success: boolean;
    is_job_send: boolean;
    exception_message: string;
  };
  //
  created_at: string | null;
  updated_at: string;
}

export interface IErrors {
  message: string;
  type: string;
}

export interface IPartnerContactDTO {
  partner_id: number;
  id: number;
  surname: string | null;
  birthday: string;
  firstname: string | null;
  lastname: string | null;
  email: string | null;
  phone_main: string | null;
  phone_additional: string | null;
  sex: INameValue<ESexOptions>;
  position: INameValue;
  technical_knowledge_level: INameValue | null;
  loyalty_level: INameValue | null;
  emotional_level: INameValue | null;
  personality_type: INameValue | null;
  is_main_contact: boolean;
  is_enabled: boolean;
  is_decision_maker: boolean;
  feedback_call_consent: boolean;
  email_marketing_consent: boolean;
  note: string;
  messengers: ImessengerItem[] | null;
  created_at: string | null;
  updated_at: string | null;
  access_to_pcp_enabled: boolean;
  access_to_pcp_finances_enabled: boolean;
  disable_pcp_access_reason: string;
  consents?: IPartnerContactConsent[];
}

export enum EMEssengers {
  SKYPE = "Skype",
}

export interface ImessengerItem {
  messenger: EMEssengers;
  login: string;
}

export enum EOriginalAvailability {
  ABSENT = "absent",
  IN_STOCK = "in_stock",
  WIHOUT_DOCUMENTS = "without_documents",
}

export interface ManagerUser {
  value: number;
  name: string;
}

export interface ManagerGroup {
  grp_name: string | null;
  users: ManagerUser[];
}

export interface TransformedOption {
  type: "group" | "option";
  label: string;
  value?: number;
  key: string;
}

export enum EContractState {
  "_0" = 0,
  "_1" = 1,
  "_2" = 2,
  "_3" = 3,
  "_4" = 4,
  "_5" = 5,
  "_6" = 6,
  "_7" = 7,
}
export enum ETaxSystem {
  "_0" = "0",
  "_1" = "1",
}
export enum EOrganizationForm {
  PrivateIndividual = 1,
  IndividualEntrepreneur = 2,
  CorporateEntity = 3,
}

export interface IPartnerContactConsent {
  partner_contact_id: number;
  consent_type: string;
}
